import "./StatisticCard.css";

export default function StatisticCard({

    title,

    value,

    subtitle = null,

    color = "primary",

}) {

    const progress = subtitle
        ? parseFloat(String(subtitle).replace("%", ""))
        : null;

    return (

        <div className="analytics-card analytics-stat-card">

            <div
                className={`analytics-card-top bg-${color}`}
            />

            <div className="analytics-card-body">

                <div className="analytics-card-title">

                    {title}

                </div>

                <div className="analytics-card-value">

                    {value}

                </div>

                {subtitle && (

                    <>

                        <div
                            className={`analytics-card-subtitle text-${color}`}
                        >

                            {subtitle}

                        </div>

                        <div className="progress analytics-progress">

                            <div
                                className={`progress-bar bg-${color}`}
                                role="progressbar"
                                style={{
                                    width: `${progress}%`,
                                }}
                            />

                        </div>

                    </>

                )}

            </div>

        </div>

    );

}
